<template>
  <div class="organisation-billing-line">
    <BillingLineContent
      ref="content"
      v-model="localPaymentInfos"
      :show-sdi-field="showSdiField"
      @disable-submit="emitDisableSubmit"
      @enable-submit="emitEnableSubmit"
      @disable-line-submit="emitInlineDisableSubmit"
      @enable-line-submit="emitInlineEnableSubmit"
    />
  </div>
</template>

<script>
import BillingLineContent from '@components/BillingLineContent';
import { mapGetters } from 'vuex';

export default {
  name: 'OrganisationBillingLine',
  components: { BillingLineContent },
  props: {
    value: {
      type: Object,
      required: true,
    },
    showSdiField: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['displayPaymentByCreditCard']),
    localPaymentInfos: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', { ...newValue });
      },
    },
  },
  mounted() {
    if (!this.displayPaymentByCreditCard) {
      this.$nextTick(() => this.$refs.content.$refs.iban.focus());
    }
  },
  methods: {
    emitDisableSubmit() {
      this.$emit('disable-submit');
    },
    emitEnableSubmit() {
      this.$emit('enable-submit');
    },
    emitInlineDisableSubmit() {
      this.$emit('disable-line-submit');
    },
    emitInlineEnableSubmit() {
      this.$emit('enable-line-submit');
    },
  },
};
</script>

<style lang="scss" scoped>
.organisation-billing-line {
  border: 1px solid $sk-grey-10;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 16px;
}
</style>
